import Titulo from '../../components/tipografia/Titulo';
import styles from './page.module.css';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import Descricao from '../../components/tipografia/Descricao';
import HBox from '../../components/layout/HBox';
import Botao from '../../components/Botao';
import VBox from '../../components/layout/VBox';
import CampoTexto from '../../components/Formulario/CampoTexto';
import Icon from '@mdi/react';
import {
  mdiBook,
  mdiBookOpen,
  mdiCalendar,
  mdiBullhorn,
  mdiHandFrontLeft,
  mdiMagnify,
  mdiPhone,
  mdiPlus,
  mdiRobot,
  mdiStethoscope,
} from '@mdi/js';
import Tabs from '../../components/layout/Tabs';
import { useMutation, useQuery } from 'react-query';
import axios from 'axios';
import Card from './Card';
import Grid, { GridItem } from '../../components/layout/Grid';
import React from 'react';
import { useDebounce } from '../chat/useDebounce';
import Skeleton from '../../components/layout/Skeleton';
import IconeCanal from '../../components/layout/IconeCanal';
import { toast } from 'react-toastify';
import Modal from '../../components/layout/Modal';
import AlertBox from '../../components/layout/AlertBox';
import { Tutorial } from '@/components/Tutorial';
import { TutoriaisKeys } from '@tera/shared/src/tutoriais/constants';
import { ModalTemplateSelector } from './ModalTemplateSelector';
import { DialogoTemplate } from '@tera/shared/src/types/DialogoTemplate';
import { useNavigate } from 'react-router-dom';
import { TRIGGER_TYPE_OPTIONS } from '@tera/shared/src/fluxoConfig/nodes/chatbot/start';

type PageProps = {};

const Page = ({ }: PageProps) => {
  const navigate = useNavigate();
  const [search, setSearch] = React.useState<string>('');
  const [fluxoTipo, setFluxoTipo] = React.useState<'atendimento' | 'voz'>('atendimento');
  const [filter, setFilter] = React.useState<any>({
    tipo: ['eq', 'atendimento'],
    inicializacao: ['eq', 'canal'],
  });
  const debouncedSearch = useDebounce(search, 500);

  const [showModalPlay, setShowModalPlay] = React.useState<number | null>(null);
  const [showModalPlaySched, setShowModalPlaySched] = React.useState<
    number | null
  >(null);
  const [showModalTemplateSelector, setShowModalTemplateSelector] = React.useState(false);
  const [pendingCanalId, setPendingCanalId] = React.useState<number | null>(null);

  const openModal = (did: number) => {
    setShowModalPlay(did);
  };

  const closeModal = () => {
    setShowModalPlay(null);
  };

  const onConfirm = async () => {
    const res = await axios.post(`/api/auth/jwt`, { did: showModalPlay });
    if (res.status !== 200) {
      console.error('Erro ao obter token');
      return;
    }
    const jwt = res.data.result;

    window.open(
      `/webchat/?a=${jwt}&t=${encodeURIComponent('/fim')}`,
      'webchatWindow',
      'popup=1',
    );
    setShowModalPlay(null);
  };

  const openModalSched = (did: number) => {
    setShowModalPlaySched(did);
  };

  const closeModalSched = () => {
    setShowModalPlaySched(null);
  };

  const onConfirmSched = async () => {
    const res = await axios.post(`/api/dialogo/${showModalPlaySched}/start`);

    closeModalSched();

    if (res.status === 200) {
      toast('Disparo agendado iniciado com sucesso', {
        toastId: 'success',
        position: 'top-center',
        type: 'success',
        autoClose: 5000,
      });
    } else {
      toast('Erro ao iniciar disparo agendado', {
        toastId: 'error',
        position: 'top-center',
        type: 'error',
        autoClose: 5000,
      });
    }
  };

  const handleOpenTemplateSelector = (canalId?: number) => {
    setPendingCanalId(canalId || null);
    setShowModalTemplateSelector(true);
  };

  const handleCloseTemplateSelector = () => {
    setShowModalTemplateSelector(false);
    setPendingCanalId(null);
  };

  const handleSelectTemplate = (template: DialogoTemplate) => {
    const templateData = encodeURIComponent(JSON.stringify(template));
    const tipoParam = fluxoTipo !== 'atendimento' ? `&tipo=${fluxoTipo}` : '';
    const url = pendingCanalId
      ? `/dialogo/novo?canal_id=${pendingCanalId}&template=${templateData}${tipoParam}`
      : `/dialogo/novo?template=${templateData}${tipoParam}`;
    navigate(url);
  };

  const query = useQuery(
    ['dialogo:search:filter', debouncedSearch, filter],
    async () => {
      const params = new URLSearchParams();
      params.append('txt', debouncedSearch);
      if (filter) {
        params.append('fi', JSON.stringify(filter));
      }
      const { data } = await axios.get('/api/dialogo?' + params.toString());
      return data;
    },
  );

  const canalBoxUrl = fluxoTipo === 'voz'
    ? '/api/canal/box?tipoIn=voip,whatsapp,wa360'
    : '/api/canal/box?tipoIn=whatsapp,wa360,webchat,telegram,facebook,instagram,email';
  const queryCanais = useQuery(['canal.box', fluxoTipo], async () => {
    const { data } = await axios.get(canalBoxUrl);
    return data;
  });

  const canaisRestantes = queryCanais.data?.result?.filter(
    (item: any) =>
      !query.data?.result?.find((dialogo: any) => dialogo.canal_id === item.id),
  );

  const executarDiagnosticos = useMutation(
    async () => {
      const { data } = await axios.post('/api/dialogo/diagnosticos/todos');
      return data;
    },
    {
      onSuccess: () => {
        toast('Diagnósticos executados com sucesso', {
          toastId: 'diagnosticos-success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
        query.refetch();
      },
      onError: () => {
        toast('Erro ao executar diagnósticos', {
          toastId: 'diagnosticos-error',
          position: 'top-center',
          type: 'error',
          autoClose: 5000,
        });
      },
    },
  );

  const delItem = useMutation(
    async (id: number) => {
      await axios.delete(`/api/dialogo/${id}`);
    },
    {
      onSuccess: () => {
        toast('Item deletado com sucesso', {
          toastId: 'success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
        query.refetch();
      },
      onError: () => {
        toast('Erro ao deletar item', {
          toastId: 'error',
          position: 'top-center',
          type: 'error',
          autoClose: 5000,
        });
      },
    },
  );

  return (
    <LayoutUsuario>
      <ModalTemplateSelector
        show={showModalTemplateSelector}
        onClose={handleCloseTemplateSelector}
        onSelectTemplate={handleSelectTemplate}
      />

      <Modal
        show={!!showModalPlay}
        onClose={closeModal}
        title="Iniciar conversa"
        onCancel={closeModal}
        onConfirm={onConfirm}
        confirmProps={{
          label: 'Continuar',
        }}
      >
        <p>Ao continuar, você poderá testar este fluxo em uma nova janela.</p>
        <AlertBox variant="warning">
          <p>O fluxo será executado na íntegra.</p>
          <p>
            <b>Chamadas de API</b> e <b>atendimentos</b> neste fluxo serão
            executadas, e poderão gerar resultados inesperados!
          </p>
        </AlertBox>
      </Modal>

      <Modal
        show={!!showModalPlaySched}
        onClose={closeModalSched}
        title="Iniciar fluxo agendado"
        onCancel={closeModalSched}
        onConfirm={onConfirmSched}
        confirmProps={{
          label: 'Continuar',
        }}
      >
        <p>Ao continuar, o fluxo será iniciado em segundo plano.</p>
        <AlertBox variant="warning">
          <p>O fluxo será executado na íntegra.</p>
          <p>
            <b>Chamadas de API</b> e <b>atendimentos</b> neste fluxo serão
            executadas, e poderão gerar resultados inesperados!
          </p>
        </AlertBox>
      </Modal>

      <VBox gap="16px" style={{ height: 'calc(100vh - 32px)' }}>
        {/* Header */}
        <Grid>
          <GridItem sm={12} md={4}>
            <VBox style={{ flex: 1 }}>
              <Titulo>{fluxoTipo === 'voz' ? 'Fluxos de voz' : 'Fluxos de atendimento'}</Titulo>
              <Descricao>{fluxoTipo === 'voz' ? 'Gerencie seus fluxos de atendimento por voz (VoIP/SIP)' : 'Gerencie seus fluxos de atendimento'}</Descricao>
            </VBox>
          </GridItem>
          <GridItem sm={12} md={4}>

            <div style={{ textAlign: 'center' }}>
              <Tutorial id={TutoriaisKeys.DIALOGO} />
            </div>
          </GridItem>
          <GridItem sm={12} md={4}>

            <div className={styles.headerAcoes} style={{ flex: 1 }}>
              <Botao variant='outline-info' icon={mdiBookOpen} href="/dialogo/manual">
                Manual
              </Botao>

              <Botao
                variant="outline-secondary"
                icon={mdiStethoscope}
                onClick={() => executarDiagnosticos.mutate()}
                disabled={executarDiagnosticos.isLoading}
              >
                {executarDiagnosticos.isLoading ? 'Executando...' : 'Diagnósticos'}
              </Botao>

              <Botao
                variant="primary"
                icon={mdiPlus}
                onClick={() => handleOpenTemplateSelector()}
              >
                {fluxoTipo === 'voz' ? 'Novo fluxo de voz' : 'Novo'}
              </Botao>
            </div>
          </GridItem>
        </Grid>

        {/* Filtros */}
        <HBox>
          <CampoTexto
            prepend={
              <Icon
                path={mdiMagnify}
                size={1}
                color="var(--tc-color-gray-500)"
              />
            }
            placeholder="Pesquisar"
            value={search}
            onChange={setSearch}
          />
        </HBox>

        <VBox gap="12px">
          {/* Tabs: Atendimento vs Voz */}
          <Tabs
            gap={8}
            size="lg"
            tabs={[
              { id: 'atendimento', label: 'Atendimento', icon: mdiRobot },
              { id: 'voz', label: 'Voz (VoIP)', icon: mdiPhone },
            ]}
            selectedTab={fluxoTipo}
            onTabChange={(tab: string) => {
              const tipo = tab as 'atendimento' | 'voz';
              setFluxoTipo(tipo);
              setFilter({ tipo: ['eq', tipo], ...(tipo === 'atendimento' ? { inicializacao: ['eq', 'canal'] } : {}) });
            }}
          />

          {/* Sub-tabs de inicialização — apenas para atendimento */}
          {fluxoTipo === 'atendimento' && (
            <Tabs
              gap={8}
              size="lg"
              tabs={[
                { id: '', label: 'Todos' },
                { id: 'canal', label: TRIGGER_TYPE_OPTIONS['canal'], icon: mdiRobot },
                {
                  id: 'agendado',
                  label: TRIGGER_TYPE_OPTIONS['agendado'],
                  icon: mdiCalendar,
                },
                {
                  id: 'manual',
                  label: TRIGGER_TYPE_OPTIONS['manual'],
                  icon: mdiHandFrontLeft,
                },
                {
                  id: 'campanha',
                  label: TRIGGER_TYPE_OPTIONS['campanha'],
                  icon: mdiBullhorn,
                },
              ]}
              selectedTab={filter.inicializacao?.[1] ?? ''}
              onTabChange={tab => {
                setFilter((prev: any) => {
                  if (tab.length) {
                    return ({ ...prev, inicializacao: ['eq', tab] })
                  }
                  else {
                    const { inicializacao, ...rest } = prev
                    return rest
                  }
                })
              }}
            />
          )}

          <Grid>
            {query.isLoading && (
              <>
                <GridItem lg={3} md={4} sm={12}>
                  <Skeleton format="card" />
                </GridItem>
                <GridItem lg={3} md={4} sm={12}>
                  <Skeleton format="card" />
                </GridItem>
                <GridItem lg={3} md={4} sm={12}>
                  <Skeleton format="card" />
                </GridItem>
              </>
            )}
            {!query.isLoading && !query.data?.result?.length && (
              <GridItem lg={12}>
                <p style={{ textAlign: 'center', padding: '16px 0' }}>
                  Nenhum item encontrado
                </p>
              </GridItem>
            )}
            {!query.isLoading &&
              query.data?.result?.map((item: any) => (
                <GridItem key={item.id} lg={3} md={4} sm={12}>
                  <Card
                    onPlay={
                      item?.canal?.tipo === 'webchat'
                        ? () => openModal(item.id)
                        : undefined
                    }
                    item={item}
                    key={item.id}
                    onRemove={() => delItem.mutate(item.id)}
                    onAck={() => query.refetch()}
                  />
                </GridItem>
              ))}
            {!query.isLoading &&
              filter?.inicializacao?.[1] === 'canal' &&
              canaisRestantes?.length > 0 &&
              canaisRestantes.map((canal: any) => (
                <GridItem key={canal.id} lg={3} md={4} sm={12}>
                  <div
                    className={styles.cardCanalSemDialogo}
                    onClick={() => handleOpenTemplateSelector(canal.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div style={{ textAlign: 'center' }}>
                      <HBox style={{ justifyContent: 'center' }}>
                        <IconeCanal
                          tipo={canal.tipo}
                          style={{ height: '14px' }}
                        />{' '}
                        {canal.nome}
                      </HBox>
                      <Icon path={mdiPlus} size={2} color="gray" />
                      <div className="text-muted fst-italic">
                        Crie um fluxo de atendimento para responder seus
                        clientes neste canal
                      </div>
                    </div>
                  </div>
                </GridItem>
              ))}
          </Grid>
        </VBox>
      </VBox>
    </LayoutUsuario>
  );
};

export default Page;
